var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { forwardRef } from 'react';
import { extractSupportProps } from '@snack-uikit/utils';
import { APPEARANCE, HTML_TYPE, ICON_POSITION, TARGET } from '../../constants';
import { APPEARANCE_TO_COLOR_MAP } from './constants';
import styles from './styles.module.css';
import { getChildren, getVariant } from './utils';
export const ButtonPrivate = forwardRef((_a, ref) => {
    var { className, disabled, href, icon, iconClassName, iconPosition = ICON_POSITION.After, label, labelClassName, loading, onClick, onKeyDown, onFocus, onBlur, counter, size, target = TARGET.Blank, type = HTML_TYPE.Button, appearance = APPEARANCE.Primary, tabIndex: tabIndexProp = 0, fullWidth } = _a, rest = __rest(_a, ["className", "disabled", "href", "icon", "iconClassName", "iconPosition", "label", "labelClassName", "loading", "onClick", "onKeyDown", "onFocus", "onBlur", "counter", "size", "target", "type", "appearance", "tabIndex", "fullWidth"]);
    const variant = getVariant({ label, iconPosition, icon });
    const children = getChildren({
        icon,
        iconClassName,
        iconPosition,
        label,
        labelClassName,
        loading,
        disabled,
        counter,
    });
    const tabIndex = loading || disabled ? -1 : tabIndexProp;
    const handleClick = (event) => {
        if (disabled || loading) {
            event.preventDefault();
            return;
        }
        if (onClick) {
            onClick(event);
        }
    };
    const buttonProps = Object.assign(Object.assign({}, extractSupportProps(rest)), { className: cn(styles.button, className), 'data-disabled': disabled || undefined, 'aria-disabled': disabled || undefined, 'data-loading': loading || undefined, 'data-size': size, 'data-full-width': fullWidth || undefined, 'data-appearance': APPEARANCE_TO_COLOR_MAP[appearance], 'data-variant': variant, onClick: handleClick, onKeyDown,
        onFocus,
        onBlur,
        tabIndex });
    if (href) {
        return (_jsx("a", Object.assign({ role: 'button', href: href, target: target }, buttonProps, { ref: ref, children: children })));
    }
    return (_jsx("button", Object.assign({}, buttonProps, { type: type, ref: ref, children: children })));
});
